export default __webpack_public_path__ + "images/loggedout/home/modularPage/modular_curve-f13f8e8fb7a90f8a344937206b2a8308.png";